import type { TranslationKeys } from "@/hooks/useTranslation/useTranslation"

const SUGGESTION_KEYS: TranslationKeys[] = [
  "AI_CHAT/SUGGESTIONS/ONE",
  "AI_CHAT/SUGGESTIONS/TWO",
  "AI_CHAT/SUGGESTIONS/THREE",
]

const MC_SUGGESTION_KEYS: TranslationKeys[] = [
  "AI_CHAT/SUGGESTIONS/MC_ONE",
  "AI_CHAT/SUGGESTIONS/MC_TWO",
  "AI_CHAT/SUGGESTIONS/MC_THREE",
]

/** Questions about the help article the user asked the agent about. Worded
 * with "this", not the title: the article is already sent along as context
 * and named in the composer chip. */
const HELP_ARTICLE_SUGGESTION_KEYS: TranslationKeys[] = [
  "AI_CHAT/SUGGESTIONS/HELP_STEPS",
  "AI_CHAT/SUGGESTIONS/HELP_WHERE",
  "AI_CHAT/SUGGESTIONS/HELP_BEFORE",
]

/** The empty chat's suggestion chips. A targeted help article wins only with
 * AGENT_HELPDESK_POLISH on, so off is main's choice exactly. */
export function chatSuggestionKeys({
  helpArticleTargeted,
  helpdeskPolish,
  materialCompliance,
}: {
  helpArticleTargeted: boolean
  helpdeskPolish: boolean
  materialCompliance: boolean
}): TranslationKeys[] {
  if (helpArticleTargeted && helpdeskPolish) return HELP_ARTICLE_SUGGESTION_KEYS
  return materialCompliance ? MC_SUGGESTION_KEYS : SUGGESTION_KEYS
}
